import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { copyToClipBoard } from '@app/shared/text.helper';
import { TranslateService } from '@ngx-translate/core';
import { mgcIconCheckboxRegular } from '@sb/mgc-icons/mgcIcon-checkbox_regular.icon';
import { mgcIconCopy2Regular } from '@sb/mgc-icons/mgcIcon-copy_2_regular.icon';
import { mgcIconHashtagRegular } from '@sb/mgc-icons/mgcIcon-hashtag_regular.icon';
import { mgcIconText2Regular } from '@sb/mgc-icons/mgcIcon-text_2_regular.icon';
import { Icon, IconComponent, IconRegistry } from '@sb/ui/icon';
import { ToastService } from '@sb/ui/toast';

import { TemplateVariable } from '../../models/contract-template.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-field-button',
  templateUrl: './fields-button.component.html',
  styleUrl: './fields-button.component.scss',
  imports: [IconComponent],
})
export class FieldsButtonComponent {
  field = input<Pick<TemplateVariable, 'type' | 'label' | 'variable' | 'custom'>>();
  isInteractive = input<boolean>(true);

  translate = inject(TranslateService);
  toast = inject(ToastService);

  fieldIcons: { [key: string]: Icon } = {
    text: 'text-2-regular',
    number: 'hashtag-regular',
    email: 'text-2-regular',
    phone: 'hashtag-regular',
    date: 'hashtag-regular',
    select: 'checkbox-regular',
  };

  constructor() {
    inject(IconRegistry).registerIcons([
      mgcIconCopy2Regular,
      mgcIconText2Regular,
      mgcIconHashtagRegular,
      mgcIconCheckboxRegular,
    ]);
  }

  copyToClipboard(text: string) {
    if (!this.isInteractive()) return;

    copyToClipBoard(`{${text}}`);
    this.toast.openSuccess(this.translate.instant('Variable [variable] copied to clipboard', { variable: text }));
  }
}
